/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import App from 'next/app';
import { appWithTranslation } from 'next-i18next';
import Error from './_error';

import { wrapper } from '../store';
import bugsnagClient from '../services/bugsnag';

const ErrorBoundary = bugsnagClient
  .getPlugin('react')
  .createErrorBoundary(React);
class AuraApp extends App {
  static getInitialProps = wrapper.getInitialAppProps(
    (store) =>
      async ({ Component, ctx }) => {
        return {
          pageProps: {
            ...(Component.getInitialProps
              ? await Component.getInitialProps({ ...ctx, store })
              : {}),
            pathname: ctx.pathname,
          },
        };
      }
  );

  render() {
    const { Component, pageProps } = this.props;
    return (
      <ErrorBoundary FallbackComponent={Error}>
        <Component {...pageProps} />
      </ErrorBoundary>
    );
  }
}

export default wrapper.withRedux(appWithTranslation(AuraApp));
